(function () {
  if (window.RTCImageOverlaySnapLoaded) return;
  window.RTCImageOverlaySnapLoaded = true;
  var instances = new WeakMap();
  var selector = '[data-rtc-image-overlay-snap-section]';

  function sectionsIn(scope) {
    var sections = Array.from(scope.querySelectorAll(selector));
    if (scope.matches && scope.matches(selector)) sections.unshift(scope);
    return sections;
  }

  function initImageOverlaySnapDrag(section) {
    if (instances.has(section)) return;
    var track = section.querySelector('[data-rtc-image-overlay-snap-track]');
    if (!track) return;
    var bar = section.querySelector('[data-rtc-image-overlay-snap-scrollbar]');
    var thumb = section.querySelector('[data-rtc-image-overlay-snap-scrollbar-thumb]');
    var controller = new AbortController();
    var mobile = window.matchMedia('(max-width: 767px)');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var pointer = null;
    var suppressClickUntil = 0;
    function on(target, type, listener, options) {
      target.addEventListener(type, listener, Object.assign({ signal: controller.signal }, options));
    }
    function maxScroll() { return Math.max(0, track.scrollWidth - track.clientWidth); }
    function active() { return mobile.matches && maxScroll() > 1; }
    function clamp(value, max) { return Math.max(0, Math.min(max, value)); }
    function scrollTo(left, instant) {
      track.scrollTo({ left: clamp(left, maxScroll()), behavior: instant || reduced.matches ? 'instant' : 'smooth' });
    }
    function update() {
      var enabled = active();
      track.tabIndex = enabled ? 0 : -1;
      if (!bar || !thumb) return;
      bar.hidden = !enabled;
      var ratio = Math.min(1, track.clientWidth / (track.scrollWidth || 1));
      var fraction = maxScroll() ? clamp(track.scrollLeft / maxScroll(), 1) : 0;
      thumb.style.width = ratio * 100 + '%';
      thumb.style.left = fraction * (1 - ratio) * 100 + '%';
      bar.setAttribute('aria-valuenow', String(Math.round(fraction * 100)));
    }
    function position(item) {
      return clamp(item.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft, maxScroll());
    }
    function snap() {
      var nearest = 0;
      var distance = Infinity;
      Array.from(track.children).forEach(function (item) {
        var left = position(item);
        if (Math.abs(left - track.scrollLeft) < distance) {
          nearest = left;
          distance = Math.abs(left - track.scrollLeft);
        }
      });
      scrollTo(nearest);
    }
    function finish(event, cancelled) {
      if (!pointer || (event && event.pointerId !== pointer.id)) return;
      var saved = pointer;
      pointer = null;
      track.classList.remove('is-dragging');
      if (saved.dragging) {
        suppressClickUntil = Date.now() + 350;
        if (!cancelled && active()) snap();
      }
      if (saved.target.hasPointerCapture(saved.id)) saved.target.releasePointerCapture(saved.id);
    }
    function start(event, onBar) {
      if (!active() || pointer || event.button !== 0 || (!onBar && event.pointerType !== 'mouse')) return;
      if (!onBar && event.target.closest('input, textarea, select, button, [contenteditable="true"]')) return;
      pointer = { id: event.pointerId, x: event.clientX, left: track.scrollLeft, target: onBar ? bar : track, bar: onBar, dragging: onBar };
      suppressClickUntil = 0;
      if (onBar) {
        event.preventDefault();
        bar.focus({ preventScroll: true });
        track.classList.add('is-dragging');
        var thumbRect = thumb.getBoundingClientRect();
        var rect = bar.getBoundingClientRect();
        var travel = rect.width - thumbRect.width;
        if (travel > 0 && (event.clientX < thumbRect.left || event.clientX > thumbRect.right)) {
          track.scrollLeft = clamp((event.clientX - rect.left - thumbRect.width / 2) / travel, 1) * maxScroll();
        }
        pointer.left = track.scrollLeft;
        bar.setPointerCapture(pointer.id);
        update();
      }
    }
    function keydown(event) {
      if (event.target !== event.currentTarget || !active()) return;
      var first = track.children[0];
      var step = first ? first.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : track.clientWidth;
      var left = track.scrollLeft;
      if (event.key === 'ArrowRight') left += step;
      else if (event.key === 'ArrowLeft') left -= step;
      else if (event.key === 'Home') left = 0;
      else if (event.key === 'End') left = maxScroll();
      else return;
      event.preventDefault();
      scrollTo(left);
    }
    on(track, 'pointerdown', function (event) { start(event, false); });
    on(window, 'pointermove', function (event) {
      if (!pointer || pointer.id !== event.pointerId) return;
      var delta = event.clientX - pointer.x;
      if (!pointer.dragging && Math.abs(delta) < 6) return;
      if (!pointer.dragging) {
        pointer.dragging = true;
        track.classList.add('is-dragging');
        track.setPointerCapture(pointer.id);
      }
      event.preventDefault();
      if (pointer.bar) {
        var travel = bar.clientWidth - thumb.getBoundingClientRect().width;
        track.scrollLeft = pointer.left + (travel > 0 ? delta / travel * maxScroll() : 0);
      } else track.scrollLeft = pointer.left - delta;
      update();
    }, { passive: false });
    on(window, 'pointerup', finish);
    on(window, 'pointercancel', function (event) { finish(event, true); });
    on(track, 'lostpointercapture', finish);
    on(track, 'dragstart', function (event) { if (active()) event.preventDefault(); });
    on(track, 'click', function (event) {
      if (event.detail !== 0 && Date.now() < suppressClickUntil) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, { capture: true });
    on(track, 'scroll', update, { passive: true });
    on(track, 'keydown', keydown);
    if (bar && thumb) {
      on(bar, 'pointerdown', function (event) { start(event, true); });
      on(bar, 'lostpointercapture', finish);
      on(bar, 'keydown', keydown);
      track.classList.add('is-enhanced');
    }
    on(section, 'shopify:block:select', function (event) {
      var item = event.target.closest('.rtc-image-overlay-snap__item');
      if (item && active()) scrollTo(position(item), true);
    });
    on(mobile, 'change', function () { finish(null, true); update(); });
    on(window, 'resize', update);
    var observer = window.ResizeObserver ? new ResizeObserver(update) : null;
    if (observer) observer.observe(track);
    update();
    instances.set(section, function () {
      finish(null, true);
      controller.abort();
      if (observer) observer.disconnect();
      track.classList.remove('is-enhanced');
      if (bar) bar.hidden = true;
      instances.delete(section);
    });
  }

  function init(scope) { sectionsIn(scope).forEach(initImageOverlaySnapDrag); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    sectionsIn(event.target).forEach(function (section) {
      var cleanup = instances.get(section);
      if (cleanup) cleanup();
    });
  });
})();
